import { Fragment } from 'react'
import { COMPLEXITY_PARTS_LIST, ComplexityDetailItem } from '../../../../../model/caf.interface'
import useIsMobile from '../../../../../modules/hooks/common/useIsMobile'
import findWordingKey from '../../../../../modules/hooks/webview/caf/common/findWordingKey'
import { s_caf } from '../../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../../modules/i18n/useTranslation'

export const ComplexityDetailSection = ({ data, index }) => {
  const products = {
    0: <ComplexityVoca getIndexData={data} />,
    1: <ComplexityCompound getIndexData={data} />,
  }
  return products[index] || null
}

export const ComplexityVoca = ({ getIndexData }: { getIndexData: ComplexityDetailItem }) => {
  const { t } = useTranslation()
  const isMobile = useIsMobile()
  /**
   * CAF P2 버전에서 품사 정보 추가되면서 22년/12월 말 이전<->이후 수업들에 대한 응답구조가 두 종류로 달라짐에 대한 분기처리 추가
   * words 하위에 품사 정보 존재하는 경우 해당 값 보여주고, 없는 경우는 기존처럼 count 값만 보여줌
   */
  const hasPosInfo = typeof Object.entries(getIndexData?.words)[0][1] === 'object' ? true : false

  const sortData = hasPosInfo
    ? Object.entries(getIndexData?.words).sort((a, b) => b[1].count - a[1].count)
    : Object.entries(getIndexData?.words).sort((a, b) => b[1] - a[1])
  if (isMobile) {
    return (
      <div className="keep-all break-words bg-white px-[20px] pt-[16px] text-gray-700">
        <span className="text-14 text-gray-700">{t(s_caf.complexity.subsection_info(getIndexData?.count))}</span>
        <div className="h-24" />
        {sortData.map((item) => (
          <div key={item[0]} className="border-b-1 mb-12 flex border-gray-100 pb-12">
            <div className="w-full">
              <span className="text-15 font-medium text-black">{item[0]}</span>
              {item[1].pos && (
                <span className="ml-[4px] text-[14px] text-gray-500">
                  [{t(findWordingKey(s_caf, { key: ['complexity', `pos`, COMPLEXITY_PARTS_LIST[item[1].pos]] }))}]
                </span>
              )}
            </div>
            <span className="text-14 text-gray-500">{hasPosInfo ? item[1].count : item[1]}</span>
          </div>
        ))}
      </div>
    )
  } else {
    return (
      <div className="keep-all w-full break-words bg-white text-gray-700">
        <span className="text-14 text-gray-700">{t(s_caf.complexity.subsection_info(getIndexData?.count))}</span>
        <div className="h-24" />
        {sortData.map((item) => (
          <div key={item[0]} className="border-b-1 mb-12 flex w-full border-gray-100 pb-12">
            <div className="w-full">
              <span className="text-15 font-medium text-black">{item[0]}</span>
              {item[1].pos && (
                <span className="ml-[4px] text-[14px] text-gray-500">
                  [{t(findWordingKey(s_caf, { key: ['complexity', `pos`, COMPLEXITY_PARTS_LIST[item[1].pos]] }))}]
                </span>
              )}
            </div>
            <span className="text-14 text-gray-500">{hasPosInfo ? item[1].count : item[1]}</span>
          </div>
        ))}
      </div>
    )
  }
}

export const ComplexityCompound = ({ getIndexData }: { getIndexData: ComplexityDetailItem }) => {
  const { t } = useTranslation()
  const isMobile = useIsMobile()

  if (isMobile) {
    return (
      <div className="keep-all break-words bg-white px-[20px] pt-[16px] text-gray-700">
        <span className="text-14 text-gray-700">{t(s_caf.complexity.subsection_info2(getIndexData?.count))}</span>
        <div className="h-24" />
        <div>
          {getIndexData?.sentences?.map((item, index) => (
            <Fragment key={item}>
              <span className="text-14 text-gray-700">{item}</span>
              <div
                className={`border-b-${getIndexData.sentences?.length - 1 === index ? 0 : 1} my-16 border-gray-100`}
              />
            </Fragment>
          ))}
        </div>
      </div>
    )
  } else {
    return (
      <div className="keep-all break-words bg-white text-gray-700">
        <span className="text-14 text-gray-700">{t(s_caf.complexity.subsection_info2(getIndexData?.count))}</span>
        <div className="h-24" />
        <div>
          {getIndexData?.sentences?.map((item, index) => (
            <Fragment key={item}>
              <span className="text-14 text-gray-700">{item}</span>
              <div
                className={`border-b-${getIndexData.sentences?.length - 1 === index ? 0 : 1} my-16 border-gray-100`}
              />
            </Fragment>
          ))}
        </div>
      </div>
    )
  }
}
